import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { useLocalizedPath } from "@/hooks/useLocalizedNavigate";
import { DirectionalArrow } from "@/components/DirectionalArrow";

const CTASection = () => {
  const { t } = useLanguage();
  const lp = useLocalizedPath();

  return (
    <section className="py-20">
      <div className="container">
        <div className="relative overflow-hidden rounded-2xl gradient-hero p-10 md:p-16">
          <div className="relative z-10 mx-auto max-w-2xl text-center">
            <h2 className="font-display text-3xl font-bold text-primary-foreground md:text-4xl">
              {t("cta_artisan.title")}
            </h2>
            <p className="mt-4 text-lg text-primary-foreground/85">
              {t("cta_artisan.subtitle")}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link to={lp("/inscription")}>
                <Button size="xl" className="bg-background text-foreground hover:bg-background/90 gap-2">
                  {t("cta_artisan.button")}
                  <DirectionalArrow className="h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-background/10" />
          <div className="absolute -bottom-8 -left-8 h-32 w-32 rounded-full bg-background/5" />
        </div>
      </div>
    </section>
  );
};

export default CTASection;
